import { createLazyReactDirective } from '../shell/createLazyReactDirective';

export default createLazyReactDirective(
  async () => (await import('./IntegrationList')).IntegrationList,
  'integrationList',
);
